const DEFAULT_APPEAL_LEVEL_LABELS = {
  manager: "المدير المباشر",
  regionalManager: "مدير المنطقة",
  departmentManager: "مدير الإدارة",
  hr: "الموارد البشرية",
};

export function isMarketingAppeal(appeal) {
  const code = String(appeal?.departmentCode || "").trim().toUpperCase();
  if (code === "MKT" || code === "MARKETING") return true;
  return /التسويق/u.test(String(appeal?.departmentName || ""));
}

export function getAppealLevelLabel(level, appeal) {
  if (appeal?.cycleLabels?.[level]) return appeal.cycleLabels[level];
  if (level === "regionalManager" && isMarketingAppeal(appeal)) {
    return "مدير المدير";
  }
  if (level === "departmentManager" && isMarketingAppeal(appeal)) {
    return "مدير إدارة التسويق";
  }
  return DEFAULT_APPEAL_LEVEL_LABELS[level] || level;
}

export function isAppealSkipLevelReviewer(appeal, employeeId) {
  if (!appeal || !employeeId) return false;
  return String(appeal.skipManagerId || "") === String(employeeId);
}
